module.exports = __webpack_public_path__ + "static/media/dna.e5151977.svg";